const carouselItems = [
  {
    title: '2024年度十佳华语电影权威盘点',
    desc: '从票房口碑到艺术成就，全面回顾年度最值得关注的十部华语电影佳作，深度解析行业趋势与创作力量。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20award%20trophy%20with%20warm%20golden%20spotlights%2C%20elegant%20red%20carpet%20ambiance%2C%20movie%20poster%20collage%20aesthetic%2C%20rich%20amber%20and%20crimson%20tones%2C%20professional%20cinematography%20style%2C%20glamorous%20lighting%2C%20grand%20ceremony%20feel&width=1200&height=600&seq=carousel-annual-film&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: '悬疑探案剧追剧指南：20部必看神作',
    desc: '从国产口碑神剧到海外经典，为你梳理一份完整的悬疑推理剧观影清单，每部都值得反复回味。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20library%20reading%20room%20with%20warm%20dramatic%20lighting%2C%20leather%20armchair%2C%20magnifying%20glass%20on%20desk%2C%20noir%20detective%20vibe%2C%20amber%20and%20deep%20brown%20tones%2C%20cinematic%20composition%2C%20elegant%20old%20world%20charm&width=1200&height=600&seq=carousel-mystery-guide&orientation=landscape',
    tag: '追剧指南',
  },
  {
    title: '国风动漫专题：东方美学的动画表达',
    desc: '聚焦近年来以中国传统文化为内核的优秀动画作品，从水墨到3D，看国漫如何讲好中国故事。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink%20painting%20style%20with%20warm%20golden%20accents%2C%20artistic%20animation%20concept%20design%2C%20elegant%20brushwork%20and%20modern%20digital%20fusion%2C%20amber%20and%20cream%20tones%2C%20cinematic%20atmosphere%2C%20poetic%20composition&width=1200&height=600&seq=carousel-chinese-anime&orientation=landscape',
    tag: '国风动漫',
  },
  {
    title: '纪录片精选：打开世界的十种方式',
    desc: '从自然奇观到人类文明，十部高分纪录片带你足不出户看遍世界，每一帧都是震撼心灵的视觉盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20aerial%20landscape%20photography%20with%20warm%20golden%20hour%20light%2C%20vast%20natural%20scenery%2C%20rich%20earth%20amber%20tones%2C%20professional%20documentary%20cinematography%2C%20elegant%20composition%2C%20breathtaking%20vista%2C%20warm%20atmosphere&width=1200&height=600&seq=carousel-doc-world&orientation=landscape',
    tag: '纪录片',
  },
  {
    title: '喜剧电影特辑：笑声中的温暖力量',
    desc: '精选国内外优秀喜剧电影，从经典老片到最新爆款，用笑声治愈生活，每一部都让你开怀大笑。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20with%20popcorn%20and%20soft%20blanket%2C%20golden%20ambient%20lighting%2C%20comfortable%20couch%2C%20cinematic%20movie%20night%20atmosphere%2C%20amber%20and%20cream%20tones%2C%20inviting%20mood%2C%20elegant%20interior%2C%20no%20people&width=1200&height=600&seq=carousel-comedy&orientation=landscape',
    tag: '喜剧特辑',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            编辑精选的深度专题内容，聚焦热门影视话题与观影趋势
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
          {carouselItems.map((item, idx) => (
            <article
              key={item.title}
              className={`group relative bg-white rounded-xl overflow-hidden border border-background-200/70 hover:shadow-md transition-all duration-300 cursor-pointer ${
                idx === 0 ? 'lg:col-span-3 lg:row-span-2' : 'lg:col-span-2'
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'h-64 md:h-80' : 'h-48 md:h-52'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md text-xs font-medium bg-primary-500 text-white">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className={`text-white font-heading mb-1 group-hover:text-accent-300 transition-colors ${
                    idx === 0 ? 'text-lg md:text-xl' : 'text-sm md:text-base'
                  }`}>
                    {item.title}
                  </h3>
                  <p className={`text-white/70 leading-relaxed ${
                    idx === 0 ? 'text-sm line-clamp-2' : 'text-xs line-clamp-2'
                  }`}>
                    {item.desc}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}